import { scrollToPosition } from '~/utils/scroll-to-position'

export const scrollToHash = (hash: string, { offset = 0, duration = 600 }) => {
  if (!hash || process.server) {
    return
  }

  const element = document.querySelector(hash)

  if (!element) {
    return
  }

  const toPosition = element.getBoundingClientRect().top + window.scrollY

  scrollToPosition(toPosition, { duration, offset })
}
